import ClosedCaptions from './ClosedCaptions'

export default ClosedCaptions
// eslint-disable-next-line import/export
export * from './ClosedCaptions'
